export default __webpack_public_path__ + "static/media/full-logo.9c15b257.svg";